import { Suspense } from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { Outlet, useLocation } from "react-router-dom";
import RouteFallback from "../../app/routing/fallback/RouteFallback";
import TopProgressBar from "../../shared/components/patterns/TopProgressBar";
import { AppNavbar, MainContent, SideMenu } from "./components";
import {
  getAppLayoutBackgroundColor,
  useSidebarDarkMode,
} from "./useAppLayoutAppearance";

export default function AppLayout() {
  const location = useLocation();
  const theme = useTheme();
  const sidebarDark = useSidebarDarkMode();
  const backgroundColor = getAppLayoutBackgroundColor(theme, sidebarDark);
  const isCanvasRoute = location.pathname === "/canais/chatbot";

  return (
    <Box
      sx={{
        backgroundColor,
        display: "flex",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <TopProgressBar />
      <SideMenu />
      <MainContent>
        <AppNavbar />
        <Suspense fallback={<RouteFallback />}>
          <Box
            key={location.pathname}
            sx={{
              animation: "routeContentIn 120ms ease-out both",
              display: "flex",
              flex: 1,
              flexDirection: "column",
              minHeight: 0,
              minWidth: 0,
              position: "relative",
              zIndex: isCanvasRoute ? theme.zIndex.appBar + 1 : "auto",
              width: "100%",
              "@keyframes routeContentIn": {
                from: {
                  opacity: 0.92,
                },
                to: {
                  opacity: 1,
                },
              },
              "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
              },
            }}
          >
            <Outlet />
          </Box>
        </Suspense>
      </MainContent>
    </Box>
  );
}
